import { SelectOptionProps } from '@acceso/design-system';
import { useMemo } from 'react';

import { useEconomicalValueChannelSources } from '../api/get-economical-value-channel-sources';
import { ChannelMediaTypeEnum, ChannelScopeEnum } from '../types';

type Filters = {
  mediaType?: ChannelMediaTypeEnum | null;
  scope?: ChannelScopeEnum | null;
  countryCode?: string;
  regionCode?: string;
};

export function useEconomicalValueChannelSourceOptions(filters?: Filters) {
  const { data: economicalValueChannelSources = [] } = useEconomicalValueChannelSources({
    params: {
      scopeIn: filters?.scope,
      mediaTypeIn: filters?.mediaType,
      countryIn: filters?.countryCode,
      regionIn: filters?.regionCode,
    },
  });

  const economicalValueChannelSourceOptions: SelectOptionProps<string>[] = useMemo(() => {
    if (!filters?.mediaType || !filters?.scope || !filters?.countryCode) {
      return [];
    }

    const options = economicalValueChannelSources.map(src => ({
      label: src.name,
      value: src.id,
    }));

    options.sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: 'base', numeric: true })
    );

    return options;
  }, [
    economicalValueChannelSources,
    filters?.mediaType,
    filters?.scope,
    filters?.countryCode,
    filters?.regionCode,
  ]);

  return economicalValueChannelSourceOptions;
}
